import React from "react";
import "./AboutBanner.css";
import personImg from "../Assets/mainban-img.png";
import overlayShape from "../Assets/Triangle.png";
import { motion } from "framer-motion";

const AboutBanner = () => {
  return (
    <section className="home-abanner" style={{background: "linear-gradient(90deg, #c30069, #3f0db3);"}}>
      {/* Left Content */}
      <motion.div
        className="home-banner-content"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h1
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
        >
                  Speak English <span>Confidently – At Every</span> Step of Your Life’s Journey
        </motion.h1>

        <motion.p
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.4 }}
        >
                 Whether you’re a Professional, a Student, an Entrepreneur or a Home Maker – we prepare you with simple, yet practical English for everyday life, business, career, and studies. Our classes are 100% Online.
        </motion.p>

                  <p style={{textAlign: "left", color: "#ffbf00"}}>Unlock the Power of Spoken English</p>
          {/* CTA Button */}
          <motion.a
            className="join-btn"
            href="/register-for-webinar"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Join our Free Webinar
           
          </motion.a>

      </motion.div>

      {/* Right Side Images */}
      <motion.div
        className="banner-images"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
      >
        <motion.img
          src={overlayShape}
          alt="Decorative Triangle Overlay"
          loading="lazy"
          className="overlayy-shape"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.7 }}
        />

        <motion.img
          src={personImg}
          alt="Student"
          loading="lazy"
          className="person-home-img"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 1 }}
        />
      </motion.div>
    </section>
  );
};

export default AboutBanner;
